module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-list"
  }, [_c('div', {
    staticClass: "flex space-between"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.createklass.subjects_for')) + "\n      " + _vm._s(_vm.activeKlassStep)), (_vm.locale !== 'en') ? _c('span', [_vm._v(".")]) : _c('span', [_vm._v(_vm._s(_vm.classesNumberized))]), _vm._v("\n      " + _vm._s(_vm.$t('vue2.createklass.grade')) + "\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Spinner', {
    attrs: {
      "color": "blue"
    }
  })], 1) : _c('ul', _vm._l((_vm.activeSubjects), function(subject) {
    return _c('li', {
      staticClass: "subject-list__subject",
      style: ({
        backgroundColor: subject.color
      })
    }, [_c('div', [_vm._v(_vm._s(subject.subject))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("removeDecimal")(subject.hours)) + _vm._s(_vm.$t('vue2.createklass.hoursPrYear')))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-98b610bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateKlasses/CreateKlassesSubjectList.vue
// module id = 1704
// module chunks = 1